import { useTranslation } from "react-i18next";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@material-ui/core";
import { useRuleContext } from "../context/ruleContext";
import SectionGroup from "./SectionGroup";
import { sectionConfigs } from "./state/sections";
import useResolvers from "./state/useResolvers";
import { FormatContext } from "./state/formatValue";

const configBySection = new Map(sectionConfigs.map(c => [c.section, c]));

export default function ConfirmUpdateModal() {
  const { t } = useTranslation("rules");
  const { state, dispatch } = useRuleContext();
  const data = state?.editData;
  const { resolvers, mapVarToLabel } = useResolvers(
    state.rule,
    Boolean(data?.showUpdateConfirm)
  );

  const formatContext: FormatContext = { t, resolvers, mapVarToLabel };

  function onCancel() {
    dispatch({ type: "updateEditData", payload: { showUpdateConfirm: false } });
  }

  function onContinue() {
    dispatch({ type: "updateEditData", payload: { showUpdateConfirm: false } });
    dispatch({ type: "saveRule" });
  }

  return (
    <Dialog open={data?.showUpdateConfirm} fullWidth maxWidth="md">
      <DialogTitle>
        <Typography variant="h6" paragraph>
          {t("confirmRuleUpdates.title")}
        </Typography>
        <Typography
          variant="body2"
          color="textSecondary"
          style={{ fontSize: "0.75rem", marginTop: "10px" }}
        >
          {t("confirmRuleUpdates.description")}
        </Typography>
      </DialogTitle>

      <DialogContent>
        {data?.changes?.map(({ section, properties }) => {
          const config = configBySection.get(section);
          if (!config) return null;
          return (
            <SectionGroup
              key={section}
              properties={properties}
              config={config}
              formatContext={formatContext}
            />
          );
        })}
      </DialogContent>

      <DialogActions style={{ marginTop: "10px" }}>
        <Button
          variant="outlined"
          color="primary"
          size="small"
          disableElevation
          onClick={onCancel}
        >
          {t("common:cancel")}
        </Button>
        <Button
          variant="contained"
          color="primary"
          size="small"
          disableElevation
          onClick={onContinue}
        >
          {t("common:continue")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
